import React from 'react';
import { moneyMinor } from '../../utils/money';

export default function DistributorOrderCashQuote({
  t,
  cashQuote,
  clinicMode,
  customerSubtotalCents,
  reviewCashQuote,
  disabled,
  quotingCash,
}) {
  const customerTotal =
    Number.isSafeInteger(customerSubtotalCents) &&
    customerSubtotalCents >= 0 &&
    Number.isSafeInteger(customerSubtotalCents + (cashQuote?.shippingCents || 0))
      ? customerSubtotalCents + (cashQuote?.shippingCents || 0)
      : null;
  return (
    <section className="me-do-section rounded-lg border p-3" aria-label={t('Order total')}>
      {!cashQuote ? (
        <button
          type="button"
          className="me-do-add-product"
          onClick={reviewCashQuote}
          disabled={disabled || quotingCash}
        >
          {t(quotingCash ? 'Calculating total...' : 'Review delivery charge and total')}
        </button>
      ) : (
        <div className="space-y-1 text-sm" aria-live="polite">
          {!clinicMode && (
            <p>
              {t('Wholesale products')}: {moneyMinor(cashQuote.productSubtotalCents)}
            </p>
          )}
          <p>
            {t('MedEffects delivery charge')}: {moneyMinor(cashQuote.shippingCents)}
          </p>
          <p className="font-semibold">
            {t(clinicMode ? 'Order total' : 'Distributor bank debit')}:{' '}
            {moneyMinor(clinicMode ? customerTotal : cashQuote.totalCents)}
          </p>
          <p className="text-xs text-slate-500">
            {t('This delivery charge is saved with your quote.')}
          </p>
        </div>
      )}
    </section>
  );
}

export function OrderAcceptance({ t, accepted, disabled, setAccepted, cashEnabled }) {
  return (
    <label className="flex items-start gap-2 text-sm">
      <input
        type="checkbox"
        checked={accepted}
        disabled={disabled}
        onChange={(event) => setAccepted(event.target.checked)}
      />
      {t(
        cashEnabled
          ? 'I accept these products, quantities, delivery details and the displayed delivery charge.'
          : 'I accept these products, quantities, delivery details and the original agreed rate.'
      )}
    </label>
  );
}

export function OrderFormFooter({ t, state }) {
  const {
    clinicMode,
    subtotal,
    cashEnabled,
    heldOrder,
    cashQuote,
    customerSubtotalCents,
    piecePricing,
    reviewCashQuote,
    submitting,
    uncertain,
    enabled,
    quotingCash,
    accepted,
    setAccepted,
    pricingAvailable,
    productsPresent,
    quotePresent,
    requestKey,
    demoOrderingDisabled,
  } = state;
  return (
    <>
      {(clinicMode || piecePricing) && (
        <div>
          <p className="text-sm font-semibold">
            {t(clinicMode ? 'Product subtotal' : 'Retail product subtotal (reporting)')}:{' '}
            {subtotal || t('Amount unavailable')} USD
          </p>
          {piecePricing && (
            <p className="text-xs text-slate-500">
              {t(
                'Retail product prices are saved for reports. The distributor bank pays wholesale products plus shipping only.'
              )}
            </p>
          )}
        </div>
      )}
      {cashEnabled && !heldOrder && (
        <DistributorOrderCashQuote
          {...{ t, cashQuote, clinicMode, customerSubtotalCents, reviewCashQuote, quotingCash }}
          disabled={submitting || uncertain || !enabled}
        />
      )}
      {(heldOrder || (cashEnabled && cashQuote)) && (
        <OrderAcceptance
          {...{ t, accepted, setAccepted, cashEnabled }}
          disabled={submitting || uncertain}
        />
      )}
      <div className="me-do-actions">
        {demoOrderingDisabled && <p role="note">{t('Demo orders cannot be submitted.')}</p>}
        <button
          type="submit"
          className="me-do-submit disabled:opacity-50"
          disabled={
            demoOrderingDisabled ||
            submitting ||
            quotingCash ||
            (cashEnabled && (!cashQuote || !accepted)) ||
            (heldOrder && !accepted) ||
            !pricingAvailable ||
            (clinicMode && !subtotal) ||
            !enabled ||
            !productsPresent ||
            !quotePresent ||
            !requestKey
          }
        >
          {t(
            submitting
              ? 'Submitting...'
              : heldOrder
                ? 'Accept and save changes'
                : clinicMode
                  ? 'Submit order'
                  : 'Submit funded order'
          )}
        </button>
      </div>
    </>
  );
}
